import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const EVRAKLAR = [
  { key: 'nufus_kayit', label: 'Nufus Kayit Ornegi', aciklama: 'Guncel nufus kayit ornegi', ikon: '📄' },
  { key: 'adli_sicil', label: 'Adli Sicil Kaydi', aciklama: 'Guncel adli sicil belgesi', ikon: '📋' },
  { key: 'kimlik_fotokopi', label: 'Kimlik Fotokopisi', aciklama: 'Arkali onlu tek sayfa', ikon: '🪪' },
  { key: 'vesikalik', label: 'Vesikalik Fotograf', aciklama: '2 adet vesikalik fotograf', ikon: '📸' },
  { key: 'ikametgah', label: 'Ikametgah Belgesi', aciklama: 'Guncel ikametgah', ikon: '🏠' },
  { key: 'diploma', label: 'Diploma / Ogrenim Belgesi', aciklama: 'Son okudugunuz okul', ikon: '🎓' },
];

const ADIMLAR = [
  { id: 'kayit', label: 'Kayit', ikon: '✅', aciklama: 'Sisteme basariyla kayit oldunuz.' },
  { id: 'telefon', label: 'Telefon Gorusmesi', ikon: '📞', aciklama: 'IK ekibimiz en kisa surede sizi arayacak.' },
  { id: 'musteri', label: 'Musteri Gorusmesi', ikon: '🤝', aciklama: 'Musteri firma ile gorusme.' },
  { id: 'teklif', label: 'Is Teklifi', ikon: '📝', aciklama: 'Resmi teklif mektubu.' },
  { id: 'sozlesme', label: 'Sozlesme', ikon: '✍️', aciklama: 'Mail adresinize gonderilen sozlesmeyi imzalayip yukleyin.' },
  { id: 'evraklar', label: 'Ise Giris Evraklari', ikon: '📁', aciklama: 'Mail adresinize iletilen evraklari sisteme yukleyiniz.' },
];

const durumAdimi = (teklif, telefonGorusmesi, musteriGorusmesi) => {
  const tDurum = teklif?.durum;
  const telDurum = telefonGorusmesi?.durum;
  const musDurum = musteriGorusmesi?.durum;
  if (tDurum === 'evraklar_yuklendi') return 6;
  if (tDurum === 'sozlesme_imzalandi') return 5;
  if (tDurum === 'sozlesme_gonderildi') return 4;
  if (tDurum === 'kabul_edildi' || tDurum === 'resmi_gonderildi') return 4;
  if (tDurum === 'sozlu_yapildi') return 3;
  if (musDurum === 'gecti' || musDurum === 'tarih_belirlendi') return 3;
  if (musDurum) return 2;
  if (telDurum === 'gecti') return 2;
  if (telDurum) return 1;
  return 0;
};

const AdayPaneliPage = () => {
  const { kullanici } = useAuth();
  const [veri, setVeri] = useState(null);
  const [telefonGorusmesi, setTelefonGorusmesi] = useState(null);
  const [musteriGorusmesi, setMusteriGorusmesi] = useState(null);
  const [evrakDosyalar, setEvrakDosyalar] = useState({});
  const [imzaliSozlesme, setImzaliSozlesme] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);
  const [aktifDetay, setAktifDetay] = useState(null);

  const yenile = () => {
    axios.get('/api/adaylar/profil').then(r => setVeri(r.data)).catch(console.error);
    if (kullanici?.id) {
      axios.get('/api/adaylar/' + kullanici.id + '/telefon-gorusmesi').then(r => setTelefonGorusmesi(r.data)).catch(console.error);
      axios.get('/api/adaylar/' + kullanici.id + '/musteri-gorusmesi').then(r => setMusteriGorusmesi(r.data)).catch(console.error);
    }
  };

  useEffect(() => { yenile(); }, [kullanici]);
  useEffect(() => { const i = setInterval(yenile, 30000); return () => clearInterval(i); }, [kullanici]);

  const handleEvrakDegis = (key, dosya) => setEvrakDosyalar(p => ({ ...p, [key]: dosya }));

  const handleEvrakYukle = async (e) => {
    e.preventDefault();
    const eksik = EVRAKLAR.filter(ev => !evrakDosyalar[ev.key]);
    if (eksik.length > 0) { setSonuc({ tip: 'hata', mesaj: eksik.map(e => e.label).join(', ') + ' zorunludur.' }); return; }
    setYukleniyor(true); setSonuc(null);
    const fd = new FormData();
    EVRAKLAR.forEach(ev => fd.append(ev.key, evrakDosyalar[ev.key]));
    try {
      await axios.post('/api/adaylar/' + kullanici.id + '/evraklar', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSonuc({ tip: 'basari', mesaj: 'Tum evraklar basariyla yuklendi!' });
      yenile();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleImzaliYukle = async (e) => {
    e.preventDefault();
    if (!imzaliSozlesme) { setSonuc({ tip: 'hata', mesaj: 'Dosya secin.' }); return; }
    setYukleniyor(true); setSonuc(null);
    const fd = new FormData();
    fd.append('imzali_sozlesme', imzaliSozlesme);
    try {
      await axios.post('/api/adaylar/' + kullanici.id + '/sozlesme/imzali', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSonuc({ tip: 'basari', mesaj: 'Imzali sozlesme yuklendi!' });
      setImzaliSozlesme(null);
      yenile();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  if (!veri) return <div style={{ padding: '2rem', color: 'var(--yazi-ikincil)' }}>Yukleniyor...</div>;

  const { aday, teklif } = veri;
  const durum = teklif?.durum;
  const aktifAdim = durumAdimi(teklif, telefonGorusmesi, musteriGorusmesi);
  const elendi = telefonGorusmesi?.durum === 'elendi' || musteriGorusmesi?.durum === 'elendi' || durum === 'reddedildi';
  const bitti = durum === 'evraklar_yuklendi';

  const adimRenk = (index) => {
    if (elendi && index === aktifAdim) return { bg: 'var(--kirmizi)', color: 'white' };
    if (index < aktifAdim) return { bg: 'var(--yesil)', color: 'white' };
    if (index === aktifAdim) return { bg: 'var(--mavi)', color: 'white' };
    return { bg: 'var(--gri-100)', color: 'var(--gri-400)' };
  };

  const adimDurum = (index) => {
    if (elendi && index === aktifAdim) return 'elendi';
    if (index < aktifAdim) return 'tamamlandi';
    if (index === aktifAdim) return 'aktif';
    return 'bekliyor';
  };

  const renderAdimDetay = (index) => {
    if (index === 0) {
      return (
        <div style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>
          ✅ Sisteme kaydiniz tamamlandi. IK ekibimiz basvurunuzu inceleyecektir.
        </div>
      );
    }

    if (index === 1) {
      if (telefonGorusmesi?.durum === 'gecti') {
        return <div style={{ fontSize: '13px', color: 'var(--yesil)' }}>✓ Telefon gorusmesini basariyla gecdiniz!</div>;
      }
      if (telefonGorusmesi?.durum === 'tarih_belirlendi') {
        return (
          <div>
            <div style={{ fontSize: '13px', fontWeight: '600', color: 'var(--mavi)', marginBottom: '8px' }}>📅 Telefon Gorusmesi Planlandi</div>
            <div style={{ background: 'var(--mavi-acik)', padding: '8px 12px', borderRadius: 'var(--radius-sm)', fontSize: '13px' }}>
              <span><strong>Tarih:</strong> {telefonGorusmesi.tarih}</span>
              {telefonGorusmesi.saat && <span style={{ marginLeft: '1rem' }}><strong>Saat:</strong> {telefonGorusmesi.saat}</span>}
            </div>
            {telefonGorusmesi.notlar && <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '8px' }}>Not: {telefonGorusmesi.notlar}</p>}
          </div>
        );
      }
      return <div style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>⏳ IK ekibimiz en kisa surede sizi arayacaktir. Lutfen telefonu acik tutun.</div>;
    }

    if (index === 2) {
      if (musteriGorusmesi?.durum === 'gecti') {
        return <div style={{ fontSize: '13px', color: 'var(--yesil)' }}>✓ Musteri gorusmesini basariyla gecdiniz!</div>;
      }
      if (musteriGorusmesi?.tarih) {
        return (
          <div>
            <div style={{ fontSize: '13px', fontWeight: '600', color: 'var(--mavi)', marginBottom: '8px' }}>🤝 Musteri Gorusmesi Planlandi</div>
            <div style={{ background: 'var(--mavi-acik)', padding: '8px 12px', borderRadius: 'var(--radius-sm)', fontSize: '13px' }}>
              <span><strong>Tarih:</strong> {musteriGorusmesi.tarih}</span>
              {musteriGorusmesi.saat && <span style={{ marginLeft: '1rem' }}><strong>Saat:</strong> {musteriGorusmesi.saat}</span>}
              {musteriGorusmesi.yer && <span style={{ marginLeft: '1rem' }}><strong>Yer:</strong> {musteriGorusmesi.yer}</span>}
            </div>
          </div>
        );
      }
      return <div style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>⏳ Musteri gorusmesi icin IK ekibimiz sizinle iletisime gececektir.</div>;
    }

    if (index === 3 && teklif) {
      return (
        <div>
          <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '8px' }}>📝 Is Teklifi Detaylari</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '13px' }}>
            <div style={{ background: 'white', padding: '8px 10px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)' }}>
              <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '2px' }}>POZISYON</div>
              <div style={{ fontWeight: '500' }}>{teklif.pozisyon}</div>
            </div>
            <div style={{ background: 'white', padding: '8px 10px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)' }}>
              <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '2px' }}>MAAS</div>
              <div style={{ fontWeight: '500' }}>{teklif.maas} TL</div>
            </div>
            <div style={{ background: 'white', padding: '8px 10px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)' }}>
              <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '2px' }}>BASLANGIC</div>
              <div style={{ fontWeight: '500' }}>{teklif.baslangic_tarihi}</div>
            </div>
          </div>
          {durum === 'resmi_gonderildi' && (
            <div style={{ marginTop: '8px', padding: '8px 10px', background: 'var(--sari-acik)', borderRadius: 'var(--radius-sm)', fontSize: '12px', color: 'var(--sari)' }}>
              📧 Resmi teklif mektubunuz e-posta adresinize gonderildi. Lutfen e-postanizi kontrol edin.
            </div>
          )}
        </div>
      );
    }

    if (index === 4) {
      if (durum === 'sozlesme_imzalandi' || durum === 'evraklar_yuklendi') {
        return (
          <div style={{ padding: '10px 12px', background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', fontSize: '13px', color: 'var(--yesil)', fontWeight: '500' }}>
            ✓ Imzali sozlesmeniz basariyla yuklendi. Tesekkurler!
          </div>
        );
      }
      if (durum === 'sozlesme_gonderildi') {
        return (
          <div>
            <div style={{ padding: '8px 10px', background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)', fontSize: '12px', color: 'var(--mavi)', marginBottom: '1rem' }}>
              📧 Sozlesmeniz e-posta adresinize gonderildi. Imzalayip asagiya yukleyin.
            </div>
            <form onSubmit={handleImzaliYukle}>
              <label style={{ display: 'block', cursor: 'pointer', marginBottom: '8px' }}>
                <input type="file" accept=".pdf,.docx" onChange={e => setImzaliSozlesme(e.target.files[0])} style={{ display: 'none' }} />
                <div style={{ border: '2px dashed var(--border)', borderRadius: 'var(--radius-sm)', padding: '12px', textAlign: 'center', fontSize: '13px', color: 'var(--yazi-ikincil)' }}>
                  {imzaliSozlesme ? <span style={{ color: 'var(--yesil)' }}>✓ {imzaliSozlesme.name}</span> : '📎 Dosya sec (PDF veya DOCX)'}
                </div>
              </label>
              <button type="submit" className="btn btn-primary btn-sm" disabled={yukleniyor || !imzaliSozlesme}>
                {yukleniyor ? 'Yukleniyor...' : 'Imzali Sozlesmeyi Yukle'}
              </button>
            </form>
          </div>
        );
      }
      return (
        <div style={{ padding: '8px 10px', background: 'var(--sari-acik)', borderRadius: 'var(--radius-sm)', fontSize: '13px', color: 'var(--sari)' }}>
          ⏳ Sozlesmeniz hazirlaniyor, e-posta adresinize gonderilecektir.
        </div>
      );
    }

    if (index === 5) {
      if (durum === 'evraklar_yuklendi') {
        return (
          <div style={{ padding: '10px 12px', background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', fontSize: '13px', color: 'var(--yesil)', fontWeight: '500' }}>
            ✓ Tum ise giris evraklariniz basariyla teslim edildi!
          </div>
        );
      }
      if (durum === 'sozlesme_imzalandi') {
        return (
          <div>
            <div style={{ padding: '8px 10px', background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)', fontSize: '12px', color: 'var(--mavi)', marginBottom: '1rem' }}>
              📧 Mail adresinize iletilen evraklari doldurup asagiya yukleyiniz. Tum belgeler zorunludur.
            </div>
            <form onSubmit={handleEvrakYukle}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '1rem' }}>
                {EVRAKLAR.map(ev => (
                  <div key={ev.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', background: evrakDosyalar[ev.key] ? 'var(--yesil-acik)' : 'white', border: '1px solid ' + (evrakDosyalar[ev.key] ? 'var(--yesil)' : 'var(--border)'), borderRadius: 'var(--radius-sm)' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <span>{ev.ikon}</span>
                      <div>
                        <div style={{ fontSize: '13px', fontWeight: '500', color: evrakDosyalar[ev.key] ? 'var(--yesil)' : 'var(--yazi)' }}>{evrakDosyalar[ev.key] ? '✓ ' : ''}{ev.label}</div>
                        <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>{ev.aciklama}</div>
                      </div>
                    </div>
                    <label style={{ cursor: 'pointer', flexShrink: 0 }}>
                      <input type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: 'none' }} onChange={e => handleEvrakDegis(ev.key, e.target.files[0])} />
                      <span className={'btn btn-sm ' + (evrakDosyalar[ev.key] ? 'btn-secondary' : 'btn-primary')}>
                        {evrakDosyalar[ev.key] ? 'Degistir' : 'Sec'}
                      </span>
                    </label>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginBottom: '8px' }}>
                {EVRAKLAR.filter(e => evrakDosyalar[e.key]).length} / {EVRAKLAR.length} belge secildi
              </div>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ width: '100%' }}>
                {yukleniyor ? 'Yukleniyor...' : 'Tum Evraklari Gonder'}
              </button>
            </form>
          </div>
        );
      }
      return <div style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>⏳ Sozlesme adimi tamamlandiktan sonra evrak yukleme aktif olacaktir.</div>;
    }

    return null;
  };

  return (
    <div>
      <div className="card" style={{ marginBottom: '1.5rem', background: 'linear-gradient(135deg, var(--mavi) 0%, var(--mavi-koyu) 100%)', border: 'none' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <div className="avatar" data-harf={aday.ad?.[0]} style={{ width: '52px', height: '52px', fontSize: '18px', background: 'rgba(255,255,255,0.2)', color: 'white', flexShrink: 0 }}>
            {aday.ad?.[0]}{aday.soyad?.[0]}
          </div>
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', color: 'white', marginBottom: '4px' }}>Hos Geldiniz, {aday.ad}!</h2>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)' }}>Is basvuru surinizi adim adim buradan takip edebilirsiniz.</p>
          </div>
          <div style={{ textAlign: 'right', flexShrink: 0 }}>
            <div style={{ fontSize: '24px', fontWeight: '700', color: 'white' }}>{aktifAdim}/{ADIMLAR.length}</div>
            <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>adim tamamlandi</div>
          </div>
        </div>
        <div style={{ marginTop: '1rem', height: '6px', background: 'rgba(255,255,255,0.2)', borderRadius: '3px' }}>
          <div style={{ height: '100%', background: 'white', borderRadius: '3px', width: Math.round(aktifAdim / ADIMLAR.length * 100) + '%', transition: 'width 0.5s' }} />
        </div>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1.5rem' }}>{sonuc.mesaj}</div>}

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '13px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '1rem' }}>Basvuru Sureci</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
          {ADIMLAR.map((adim, index) => {
            const ds = adimDurum(index);
            const renk = adimRenk(index);
            const acik = aktifDetay === index;
            const tiklanabilir = ds === 'aktif' || ds === 'tamamlandi';
            return (
              <div key={adim.id}>
                <div onClick={() => tiklanabilir && setAktifDetay(acik ? null : index)}
                  style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', borderRadius: 'var(--radius-sm)', cursor: tiklanabilir ? 'pointer' : 'default', background: acik ? 'var(--mavi-acik)' : ds === 'aktif' ? 'var(--gri-50)' : 'transparent', transition: 'background 0.15s', marginBottom: '4px' }}>
                  <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: renk.bg, color: renk.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: '600', flexShrink: 0 }}>
                    {ds === 'tamamlandi' ? '✓' : ds === 'elendi' ? '✗' : adim.ikon}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <span style={{ fontSize: '14px', fontWeight: ds === 'aktif' ? '600' : '500', color: ds === 'aktif' ? 'var(--mavi)' : ds === 'tamamlandi' ? 'var(--yesil)' : ds === 'elendi' ? 'var(--kirmizi)' : 'var(--gri-400)' }}>
                        {adim.label}
                      </span>
                      {ds === 'aktif' && <span style={{ fontSize: '11px', background: 'var(--mavi)', color: 'white', padding: '1px 6px', borderRadius: '10px' }}>Aktif</span>}
                      {ds === 'tamamlandi' && <span style={{ fontSize: '11px', color: 'var(--yesil)' }}>Tamamlandi</span>}
                      {ds === 'elendi' && <span style={{ fontSize: '11px', color: 'var(--kirmizi)' }}>Elendiniz</span>}
                    </div>
                    {(ds === 'aktif' || ds === 'tamamlandi') && <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>{adim.aciklama}</div>}
                  </div>
                  {tiklanabilir ? <span style={{ fontSize: '12px', color: 'var(--mavi)', flexShrink: 0 }}>{acik ? '▲' : '▼'}</span> : ds === 'bekliyor' && <span style={{ fontSize: '14px', color: 'var(--gri-400)', flexShrink: 0 }}>🔒</span>}
                </div>
                {acik && (
                  <div style={{ margin: '0 0 8px 48px', padding: '1rem', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', borderLeft: '3px solid var(--mavi)' }}>
                    {renderAdimDetay(index)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {elendi && (
        <div className="card" style={{ borderLeft: '4px solid var(--kirmizi)', background: 'var(--kirmizi-acik)' }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: 'var(--kirmizi)', marginBottom: '4px' }}>Basvurunuz Sonuclandi</div>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Maalesef bu surece ilerleme saglanamadi. Gelecekteki firsatlar icin basvurularinizi bekliyoruz.</p>
        </div>
      )}
      {bitti && (
        <div className="card" style={{ borderLeft: '4px solid var(--yesil)', background: 'var(--yesil-acik)' }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: 'var(--yesil)', marginBottom: '4px' }}>🎉 Surec Tamamlandi!</div>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Tum evraklariniz basariyla teslim edilmistir. IK ekibimiz sizinle iletisime gececektir.</p>
        </div>
      )}
    </div>
  );
};
export default AdayPaneliPage;
